var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory9532032(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "category_9532032",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63375",
    "data-name": "Path 63375",
    d: "M9.893,4H6.857A2.861,2.861,0,0,0,4,6.857V9.893A2.861,2.861,0,0,0,6.857,12.75h5.536a.358.358,0,0,0,.357-.357V6.857A2.861,2.861,0,0,0,9.893,4Z",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63376",
    "data-name": "Path 63376",
    d: "M12.393,35.5H6.857A2.861,2.861,0,0,0,4,38.357v3.036A2.861,2.861,0,0,0,6.857,44.25H9.893a2.861,2.861,0,0,0,2.857-2.857V35.857a.358.358,0,0,0-.357-.357Z",
    transform: "translate(0 -20.25)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1978",
    "data-name": "Ellipse 1978",
    cx: 4.375,
    cy: 4.375,
    r: 4.375,
    transform: "translate(15.25 4)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63377",
    "data-name": "Path 63377",
    d: "M41.393,35.48H35.857a.358.358,0,0,0-.357.357v5.536a2.859,2.859,0,0,0,2.857,2.857h3.036a2.859,2.859,0,0,0,2.857-2.857V38.337A2.861,2.861,0,0,0,41.393,35.48Z",
    transform: "translate(-20.25 -20.237)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory9532032);
export default __webpack_public_path__ + "static/media/category_9532032.9e4db92ed239125885d06c7cd07014f0.svg";
export { ForwardRef as ReactComponent };